import { render, staticRenderFns } from "./PropertyHolder.vue?vue&type=template&id=3a402eab&scoped=true&"
import script from "./PropertyHolder.vue?vue&type=script&lang=js&"
export * from "./PropertyHolder.vue?vue&type=script&lang=js&"
import style0 from "./PropertyHolder.vue?vue&type=style&index=0&id=3a402eab&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a402eab",
  null
  
)

export default component.exports